module.exports = __webpack_public_path__ + "static/img/diandongche.4f4e9eba.png";